import type { MediaItem } from "@/types/media";

export const mediaList: MediaItem[] = [
  {
    id: "m001",
    title: "星际回响",
    type: "movie",
    region: "国产",
    year: 2024,
    genres: ["科幻", "冒险"],
    rating: 8.7,
    heat: 9820,
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20movie%20poster%20of%20a%20lone%20astronaut%20standing%20before%20a%20glowing%20ringed%20planet%2C%20deep%20navy%20and%20amber%20color%20palette%2C%20dramatic%20volumetric%20lighting%2C%20epic%20scale%2C%20minimal%20clean%20composition%20with%20empty%20space%20at%20top%2C%20high%20detail%20editorial%20poster%20art&width=600&height=800&seq=17c-poster-001&orientation=portrait",
    synopsis: "一场跨越四十光年的信号回响，让被困在空间站的三名宇航员重新审视人类文明的孤独与希望。",
    director: "陆知远",
    cast: ["江屹", "苏晚", "顾承宇"],
    episodes: 1,
    duration: "128分钟",
    tags: ["硬科幻", "太空", "高口碑"],
  },
  {
    id: "m002",
    title: "长安夜行",
    type: "tv",
    region: "国产",
    year: 2024,
    genres: ["古装", "悬疑"],
    rating: 9.1,
    heat: 12040,
    cover: "https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20poster%20of%20an%20ancient%20walled%20city%20at%20night%20with%20red%20lanterns%20and%20misty%20streets%2C%20silhouette%20of%20a%20robed%20figure%2C%20deep%20indigo%20and%20warm%20orange%20tones%2C%20moody%20cinematic%20lighting%2C%20elegant%20vertical%20composition%2C%20premium%20poster%20illustration&width=600&height=800&seq=17c-poster-002&orientation=portrait",
    synopsis: "长安城一夜间连发三起离奇命案，落魄捕快与大理寺少卿被迫联手，揭开藏在盛世之下的惊天旧案。",
    director: "沈鹤鸣",
    cast: ["裴照", "温宁", "程砚"],
    episodes: 36,
    duration: "单集45分钟",
    tags: ["古装探案", "烧脑", "口碑神作"],
  },
  {
    id: "m003",
    title: "山海迷城",
    type: "movie",
    region: "国产",
    year: 2023,
    genres: ["奇幻", "冒险"],
    rating: 8.2,
    heat: 8760,
    cover: "https://readdy.ai/api/search-image?query=Fantasy%20adventure%20film%20poster%20of%20a%20mythical%20floating%20mountain%20city%20above%20clouds%20with%20ancient%20architecture%20and%20waterfalls%2C%20teal%20and%20gold%20color%20palette%2C%20dreamy%20atmospheric%20light%2C%20vertical%20epic%20composition%2C%20highly%20detailed%20matte%20painting&width=600&height=800&seq=17c-poster-003&orientation=portrait",
    synopsis: "少年误入藏于云雾中的山海迷城，为寻找失踪的兄长，他必须在三天内破解古城机关与失传的星图。",
    director: "韩牧",
    cast: ["林野", "白露", "周珩"],
    episodes: 1,
    duration: "134分钟",
    tags: ["东方奇幻", "视觉盛宴"],
  },
  {
    id: "m004",
    title: "沉默的证人",
    type: "tv",
    region: "国产",
    year: 2024,
    genres: ["悬疑", "犯罪"],
    rating: 8.9,
    heat: 10450,
    cover: "https://readdy.ai/api/search-image?query=Crime%20thriller%20series%20poster%20of%20a%20solemn%20detective%20figure%20in%20a%20rainy%20alley%20lit%20by%20a%20single%20cold%20streetlamp%2C%20deep%20slate%20blue%20and%20dim%20amber%20tones%2C%20noir%20cinematic%20mood%2C%20vertical%20poster%20layout%20with%20negative%20space%20at%20bottom&width=600&height=800&seq=17c-poster-004&orientation=portrait",
    synopsis: "一名失忆的目击者成为悬案唯一突破口，刑警顾言在真话与谎言之间，拼出一场精心策划十年的复仇。",
    director: "郑维",
    cast: ["顾言", "许澄", "罗劲"],
    episodes: 24,
    duration: "单集42分钟",
    tags: ["悬疑推理", "反转"],
  },
  {
    id: "m005",
    title: "东京物语新编",
    type: "movie",
    region: "日韩",
    year: 2023,
    genres: ["剧情", "家庭"],
    rating: 7.8,
    heat: 6420,
    cover: "https://readdy.ai/api/search-image?query=Quiet%20family%20drama%20film%20poster%20showing%20an%20elderly%20couple%20seated%20by%20a%20train%20window%20at%20dusk%2C%20warm%20sepia%20and%20soft%20muted%20tones%2C%20gentle%20natural%20light%2C%20restrained%20elegant%20vertical%20composition%20with%20ample%20negative%20space&width=600&height=800&seq=17c-poster-005&orientation=portrait",
    synopsis: "一对老夫妻的短暂东京之行，照见一个普通家庭在时代变迁中悄悄改变的距离与牵挂。",
    director: "佐藤悠真",
    cast: ["内田良子", "小林茂", "宫本遥"],
    episodes: 1,
    duration: "112分钟",
    tags: ["生活流", "治愈"],
  },
  {
    id: "m006",
    title: "西部往事",
    type: "tv",
    region: "欧美",
    year: 2024,
    genres: ["西部", "剧情"],
    rating: 8.5,
    heat: 9310,
    cover: "https://readdy.ai/api/search-image?query=Western%20series%20poster%20of%20a%20lone%20cowboy%20silhouette%20on%20a%20dusty%20desert%20road%20at%20golden%20sunset%2C%20rust%20orange%20and%20deep%20brown%20palette%2C%20cinematic%20atmospheric%20light%2C%20wide%20epic%20feel%20in%20a%20vertical%20poster%20format&width=600&height=800&seq=17c-poster-006&orientation=portrait",
    synopsis: "十九世纪末的西部边境，一名退隐枪手为了守护小镇，不得不重新面对自己试图埋葬的过去。",
    director: "Daniel Rowe",
    cast: ["Ethan Hale", "Mara Quinn", "Cole Brennan"],
    episodes: 10,
    duration: "单集55分钟",
    tags: ["硬派西部", "史诗"],
  },
  {
    id: "m007",
    title: "时空旅人",
    type: "movie",
    region: "欧美",
    year: 2024,
    genres: ["科幻", "爱情"],
    rating: 8.8,
    heat: 10120,
    cover: "https://readdy.ai/api/search-image?query=Romantic%20sci-fi%20movie%20poster%20of%20two%20figures%20reaching%20toward%20each%20other%20across%20swirling%20time%20portals%2C%20teal%20and%20copper%20color%20scheme%2C%20glowing%20light%20trails%2C%20ethereal%20dreamlike%20mood%2C%20sophisticated%20vertical%20poster%20composition&width=600&height=800&seq=17c-poster-007&orientation=portrait",
    synopsis: "物理学家在一次实验意外中开始逆向穿越时间，他唯一想改变的那一天，恰是失去爱人的那一天。",
    director: "Clara Mason",
    cast: ["Liam Foster", "Nora Ellis", "Adam Cole"],
    episodes: 1,
    duration: "131分钟",
    tags: ["浪漫科幻", "催泪"],
  },
  {
    id: "m008",
    title: "我们的白昼流星",
    type: "tv",
    region: "国产",
    year: 2023,
    genres: ["青春", "爱情"],
    rating: 7.6,
    heat: 7230,
    cover: "https://readdy.ai/api/search-image?query=Youth%20romance%20series%20poster%20of%20two%20students%20on%20a%20school%20rooftop%20under%20a%20bright%20sky%20with%20faint%20meteor%20trails%2C%20sky%20blue%20and%20peach%20pastel%20tones%2C%20airy%20nostalgic%20mood%2C%20clean%20vertical%20composition&width=600&height=800&seq=17c-poster-008&orientation=portrait",
    synopsis: "小镇少女与天文社少年因一场流星雨相识，在高三的最后一年，他们一起仰望同一片天空。",
    director: "许南",
    cast: ["夏梨", "陈屿", "温小满"],
    episodes: 30,
    duration: "单集40分钟",
    tags: ["青春校园", "治愈"],
  },
  {
    id: "m009",
    title: "深海来信",
    type: "movie",
    region: "国产",
    year: 2024,
    genres: ["动画", "奇幻"],
    rating: 9.0,
    heat: 11230,
    cover: "https://readdy.ai/api/search-image?query=Animated%20fantasy%20film%20poster%20of%20a%20small%20child%20diver%20surrounded%20by%20glowing%20jellyfish%20in%20a%20deep%20blue%20ocean%20with%20sunlight%20rays%20from%20above%2C%20teal%20and%20warm%20gold%20accents%2C%20whimsical%20dreamy%20mood%2C%20vertical%20poster&width=600&height=800&seq=17c-poster-009&orientation=portrait",
    synopsis: "一封漂流了百年的信，把害怕深水的小女孩带进海底的古老城市，去完成一场跨越时间的约定。",
    director: "叶澄",
    cast: ["配音：林澄", "配音：周乐", "配音：安然"],
    episodes: 1,
    duration: "106分钟",
    tags: ["国漫", "合家欢"],
  },
  {
    id: "m010",
    title: "综艺大咖秀",
    type: "variety",
    region: "国产",
    year: 2024,
    genres: ["综艺", "真人秀"],
    rating: 7.9,
    heat: 8640,
    cover: "https://readdy.ai/api/search-image?query=Bright%20entertainment%20variety%20show%20poster%20with%20colorful%20stage%20lights%20and%20confetti%2C%20abstract%20microphone%20and%20spotlight%20shapes%2C%20vivid%20coral%20and%20navy%20color%20palette%2C%20playful%20energetic%20mood%2C%20bold%20vertical%20poster%20composition&width=600&height=800&seq=17c-poster-010&orientation=portrait",
    synopsis: "十二位跨界嘉宾同台竞技，用即兴表演和真心话挑战，带来一整季笑点与泪点齐飞的欢乐现场。",
    director: "何乐",
    cast: ["沈乐乐", "阿哲", "孟楠"],
    episodes: 12,
    duration: "单集90分钟",
    tags: ["爆笑", "下饭综艺"],
  },
  {
    id: "m011",
    title: "城市边缘",
    type: "movie",
    region: "欧美",
    year: 2023,
    genres: ["犯罪", "惊悚"],
    rating: 8.1,
    heat: 7890,
    cover: "https://readdy.ai/api/search-image?query=Neo-noir%20crime%20thriller%20poster%20of%20a%20lone%20figure%20walking%20through%20a%20rain-soaked%20city%20street%20at%20night%20with%20neon%20reflections%2C%20muted%20steel%20blue%20and%20dim%20amber%2C%20gritty%20cinematic%20mood%2C%20vertical%20poster%20layout&width=600&height=800&seq=17c-poster-011&orientation=portrait",
    synopsis: "一名夜班出租车司机无意中卷入连环案件，城市的边缘地带藏着谁都不愿提起的秘密。",
    director: "Marc Devlin",
    cast: ["Owen Reed", "Isla Grant", "Tomas Vela"],
    episodes: 1,
    duration: "118分钟",
    tags: ["犯罪", "氛围感"],
  },
  {
    id: "m012",
    title: "一屋两人三餐",
    type: "tv",
    region: "日韩",
    year: 2024,
    genres: ["治愈", "生活"],
    rating: 8.4,
    heat: 8010,
    cover: "https://readdy.ai/api/search-image?query=Cozy%20slice%20of%20life%20series%20poster%20of%20a%20warm%20sunlit%20kitchen%20with%20two%20plates%20on%20a%20wooden%20table%20and%20hanging%20plants%2C%20soft%20cream%20and%20sage%20green%20tones%2C%20gentle%20morning%20light%2C%20calm%20vertical%20composition&width=600&height=800&seq=17c-poster-012&orientation=portrait",
    synopsis: "同居的第一百天，两个不擅长表达的人，靠一日三餐慢慢学会如何说喜欢。",
    director: "金秀贤",
    cast: ["李海岸", "朴恩秀", "郑玹宇"],
    episodes: 16,
    duration: "单集38分钟",
    tags: ["慢生活", "下饭"],
  },
  {
    id: "m013",
    title: "逆风翻盘",
    type: "tv",
    region: "国产",
    year: 2024,
    genres: ["运动", "励志"],
    rating: 8.3,
    heat: 8420,
    cover: "https://readdy.ai/api/search-image?query=Sports%20drama%20series%20poster%20of%20a%20determined%20athlete%20silhouette%20sprinting%20on%20a%20running%20track%20at%20sunrise%2C%20energetic%20orange%20and%20deep%20navy%20palette%2C%20motion%20blur%20and%20dramatic%20backlight%2C%20bold%20vertical%20poster%20composition&width=600&height=800&seq=17c-poster-013&orientation=portrait",
    synopsis: "被伤病击碎梦想的短跑选手，回到县城中学执教，带着一群不被看好的少年重新冲上跑道。",
    director: "方野",
    cast: ["韩川", "林晚晴", "石磊"],
    episodes: 28,
    duration: "单集42分钟",
    tags: ["热血", "励志"],
  },
  {
    id: "m014",
    title: "沙漠之眼",
    type: "movie",
    region: "欧美",
    year: 2022,
    genres: ["冒险", "动作"],
    rating: 7.7,
    heat: 6120,
    cover: "https://readdy.ai/api/search-image?query=Adventure%20action%20movie%20poster%20of%20a%20lone%20explorer%20before%20vast%20sweeping%20sand%20dunes%20with%20an%20ancient%20ruin%20gateway%2C%20amber%20and%20burnt%20sienna%20palette%2C%20harsh%20dramatic%20sunlight%2C%20epic%20vertical%20poster%20layout&width=600&height=800&seq=17c-poster-014&orientation=portrait",
    synopsis: "一支考古队在沙漠深处发现神秘遗迹，随着沙暴逼近，贪念与信任在绝境中开始崩塌。",
    director: "Karl Sundgren",
    cast: ["Diego Marsh", "Lena Frost", "Sam Okoro"],
    episodes: 1,
    duration: "124分钟",
    tags: ["冒险", "大片"],
  },
  {
    id: "m015",
    title: "花间令",
    type: "tv",
    region: "国产",
    year: 2023,
    genres: ["古装", "爱情"],
    rating: 8.0,
    heat: 7610,
    cover: "https://readdy.ai/api/search-image?query=Elegant%20Chinese%20costume%20drama%20poster%20of%20a%20woman%20in%20flowing%20hanfu%20standing%20in%20a%20peach%20blossom%20garden%2C%20soft%20pink%20and%20jade%20green%20palette%2C%20dreamy%20petal%20light%2C%20refined%20vertical%20poster%20composition%20with%20negative%20space&width=600&height=800&seq=17c-poster-015&orientation=portrait",
    synopsis: "身负旧案之谜的府中女官，与冷面王爷在宫墙花影之间，从试探到并肩，卷入朝堂风云。",
    director: "苏 Muse",
    cast: ["姜辞书", "裴知远", "温如许"],
    episodes: 40,
    duration: "单集45分钟",
    tags: ["古言", "甜虐"],
  },
  {
    id: "m016",
    title: "极速前进",
    type: "variety",
    region: "国产",
    year: 2024,
    genres: ["综艺", "竞技"],
    rating: 8.2,
    heat: 8150,
    cover: "https://readdy.ai/api/search-image?query=Adventure%20competition%20variety%20show%20poster%20with%20a%20globe%2C%20racing%20flags%20and%20dynamic%20speed%20lines%2C%20vivid%20teal%20and%20orange%20color%20palette%2C%20energetic%20sporty%20mood%2C%20bold%20vertical%20poster%20layout&width=600&height=800&seq=17c-poster-016&orientation=portrait",
    synopsis: "八组搭档横跨六座城市完成极限任务，速度、默契与策略，谁能笑到最后？",
    director: "吴竞",
    cast: ["李速", "王冲到", "赵一路"],
    episodes: 14,
    duration: "单集80分钟",
    tags: ["竞技", "热血"],
  },
  {
    id: "m017",
    title: "星尘记忆",
    type: "movie",
    region: "国产",
    year: 2023,
    genres: ["科幻", "剧情"],
    rating: 8.6,
    heat: 9040,
    cover: "https://readdy.ai/api/search-image?query=Thoughtful%20sci-fi%20drama%20movie%20poster%20of%20a%20human%20profile%20dissolving%20into%20glowing%20stardust%20particles%20against%20deep%20space%2C%20indigo%20and%20soft%20silver%20tones%2C%20serene%20contemplative%20mood%2C%20minimal%20vertical%20poster&width=600&height=800&seq=17c-poster-017&orientation=portrait",
    synopsis: "在记忆可以被写入芯片的未来，一位工程师发现，自己珍藏的童年回忆竟然属于另一个人。",
    director: "程亦",
    cast: ["沈舟", "苏漫", "顾清和"],
    episodes: 1,
    duration: "120分钟",
    tags: ["软科幻", "泪目"],
  },
  {
    id: "m018",
    title: "雨夜告白",
    type: "movie",
    region: "日韩",
    year: 2024,
    genres: ["爱情", "悬疑"],
    rating: 7.9,
    heat: 6980,
    cover: "https://readdy.ai/api/search-image?query=Moody%20romantic%20mystery%20movie%20poster%20of%20two%20figures%20sharing%20a%20transparent%20umbrella%20in%20heavy%20rain%20under%20a%20streetlamp%2C%20cool%20slate%20blue%20and%20soft%20amber%20tones%2C%20intimate%20cinematic%20mood%2C%20vertical%20poster&width=600&height=800&seq=17c-poster-018&orientation=portrait",
    synopsis: "每个雨夜，她都会收到同一把伞；而当她终于看清撑伞人，真相却让这个夏天再也回不去。",
    director: "崔浩然",
    cast: ["尹世真", "朴度贤", "林素妍"],
    episodes: 1,
    duration: "109分钟",
    tags: ["爱情悬疑", "氛围"],
  },
  {
    id: "m019",
    title: "边境迷航",
    type: "tv",
    region: "欧美",
    year: 2023,
    genres: ["悬疑", "冒险"],
    rating: 8.5,
    heat: 8720,
    cover: "https://readdy.ai/api/search-image?query=Suspense%20adventure%20series%20poster%20of%20a%20misty%20pine%20forest%20borderland%20with%20a%20distant%20lone%20headlight%20and%20cold%20fog%2C%20deep%20green%20slate%20and%20pale%20silver%20palette%2C%20eerie%20cinematic%20mood%2C%20vertical%20poster%20composition&width=600&height=800&seq=17c-poster-019&orientation=portrait",
    synopsis: "一辆驶向边境的夜班巴士在暴雪中失联，七名陌生乘客发现，他们每个人都与一桩旧案有关。",
    director: "Hannah Berg",
    cast: ["Felix Nordin", "Rhea Cole", "Jonas Vik"],
    episodes: 8,
    duration: "单集52分钟",
    tags: ["悬疑", "群像"],
  },
  {
    id: "m020",
    title: "厨房交响曲",
    type: "variety",
    region: "国产",
    year: 2024,
    genres: ["综艺", "美食"],
    rating: 8.1,
    heat: 7330,
    cover: "https://readdy.ai/api/search-image?query=Warm%20cooking%20variety%20show%20poster%20of%20steaming%20dishes%20and%20fresh%20ingredients%20on%20a%20rustic%20wooden%20counter%2C%20cream%20and%20terracotta%20tones%2C%20cozy%20inviting%20light%2C%20tidy%20vertical%20poster%20composition&width=600&height=800&seq=17c-poster-020&orientation=portrait",
    synopsis: "六位素人厨艺爱好者走进同一间厨房，用一日三餐讲述属于自己的家乡味道与人生故事。",
    director: "李灶",
    cast: ["主厨：陈味", "嘉宾：苏禾", "嘉宾：郑满"],
    episodes: 10,
    duration: "单集60分钟",
    tags: ["美食", "治愈"],
  },
  {
    id: "m021",
    title: "追光者",
    type: "movie",
    region: "国产",
    year: 2024,
    genres: ["剧情", "励志"],
    rating: 8.7,
    heat: 9450,
    cover: "https://readdy.ai/api/search-image?query=Inspiring%20drama%20movie%20poster%20of%20a%20lone%20young%20photographer%20silhouette%20facing%20a%20vast%20golden%20sunrise%20over%20the%20sea%2C%20warm%20amber%20and%20deep%20navy%20palette%2C%20hopeful%20cinematic%20light%2C%20vertical%20poster%20with%20negative%20space&width=600&height=800&seq=17c-poster-021&orientation=portrait",
    synopsis: "一个用镜头记录城市变迁的女孩，在一次次按下快门的瞬间，也重新找回了走失的自己。",
    director: "林澈",
    cast: ["许光", "周宁", "叶南舟"],
    episodes: 1,
    duration: "115分钟",
    tags: ["励志", "治愈"],
  },
  {
    id: "m022",
    title: "无声的证词",
    type: "tv",
    region: "国产",
    year: 2023,
    genres: ["犯罪", "悬疑"],
    rating: 8.8,
    heat: 9880,
    cover: "https://readdy.ai/api/search-image?query=Crime%20mystery%20series%20poster%20of%20a%20focused%20forensic%20examiner%20examining%20clues%20under%20cool%20lab%20lighting%2C%20steel%20blue%20and%20muted%20teal%20palette%2C%20precise%20clinical%20mood%2C%20clean%20vertical%20poster%20composition&width=600&height=800&seq=17c-poster-022&orientation=portrait",
    synopsis: "法医秦朗相信，尸体不会撒谎。面对一桩被判定为意外的命案，他从最细微的痕迹里听见了死者无声的证词。",
    director: "顾廷",
    cast: ["秦朗", "沈静", "陆锋"],
    episodes: 26,
    duration: "单集43分钟",
    tags: ["法医", "硬核推理"],
  },
];